import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { Manufacturer, ManufacturerWithTurbines } from '../models/technical-resource'
import { DISABLE_SPINNER_CONTEXT } from '../interceptors/loading-spinner.interceptor'

@Injectable({
  providedIn: 'root',
})
export class ManufacturerService {
  private readonly http = inject(HttpClient)
  private readonly baseUrl = environment.apiUrl

  getWindManufacturers(): Observable<Manufacturer[]> {
    return this.http.get<Manufacturer[]>(`${this.baseUrl}/manufacturer/wind`, {
      context: DISABLE_SPINNER_CONTEXT,
    })
  }

  getWindManufacturerTurbines(name: string): Observable<ManufacturerWithTurbines> {
    return this.http.get<ManufacturerWithTurbines>(`${this.baseUrl}/manufacturer/wind/${encodeURIComponent(name)}`, {
      context: DISABLE_SPINNER_CONTEXT,
    })
  }
}
